import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function ImpactoEconomicoPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="analisis"
      subsectionPath="impacto-economico"
    />
  );
}
